import { FeatureValue } from "@omni/types/api/product/bff/shared/featureValue.model";
import { CloudFeatureValue } from "@omni/types/api/product/cloud/shared/featureValue.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const fromCloudToBff: ModelMapper<CloudFeatureValue, FeatureValue> = (
    model
) => {
    return {
        formattedValue: model.formattedValue,
        code: model.code,
        description: model.description,
        imageURL: model.imageURL,
        thumbnailURL: model.thumbnailURL,
        valid: model.valid
    } satisfies FeatureValue;
};

const fromAlgoliaSearchToBff: ModelMapper<string, FeatureValue> = (model) => {
    return {
        formattedValue: model
    } satisfies FeatureValue;
};

const fromBffSearchToBff: ModelMapper<string, FeatureValue> = (model) => {
    return {
        formattedValue: model
    } satisfies FeatureValue;
};

const fromBffToAlgoliaSearch: ModelMapper<FeatureValue, string> = (model) => {
    return model.formattedValue;
};

const fromBffToBffSearch: ModelMapper<FeatureValue, string> = (model) => {
    return model.formattedValue;
};

export const FeatureValueMapper = {
    fromCloudToBff: fromCloudToBff,
    fromAlgoliaSearchToBff: fromAlgoliaSearchToBff,
    fromBffSearchToBff: fromBffSearchToBff,
    fromBffToAlgoliaSearch: fromBffToAlgoliaSearch,
    fromBffToBffSearch: fromBffToBffSearch
};
